import { gql } from '@apollo/client';

export const CREATE_GROUND_WATER_MONITOR = gql`
    mutation CreateGroundWaterMonitor($input: CreateGroundWaterMonitor!) {
        facility {
            process {
                createGroundWaterMonitor(input: $input) {
                    id
                }
            }
        }
    }
`;
